import * as Yup from 'yup'
import mean from 'lodash/mean'

import type { ResearchReportDocument } from '@pepper/utils/src/types/seo'

export const metricFormStep = {
  1: {
    title: 'Edit Guideline Metrics',
    description:
      'Adjust the content length to fit your needs. Once set, all other metrics will automatically scale and adjust accordingly.',
  },
  2: {
    title: 'Edit Guideline Metrics',
    description:
      'Content length set! The other metrics have been automatically scaled based on your input. Feel free to customize further.',
  },
}

export function getInitialMetricFormValues(report: ResearchReportDocument) {
  return {
    content_length: Math.floor(
      mean([report.page_length.min, report.page_length.max])
    ),
    hx: Math.floor(
      mean([report.element_counts.hx.min, report.element_counts.hx.max])
    ),
    p: Math.floor(
      mean([report.element_counts.p.min, report.element_counts.p.max])
    ),
    img: Math.floor(
      mean([report.element_counts.img.min, report.element_counts.img.max])
    ),
    a: Math.floor(
      mean([report.element_counts.a.min, report.element_counts.a.max])
    ),
  }
}

const NUMBER_TYPE_ERROR_MESSAGE = 'You must specify a number'

export const metricsValidationSchema = Yup.object().shape({
  content_length: Yup.number().typeError(NUMBER_TYPE_ERROR_MESSAGE),
  hx: Yup.number().typeError(NUMBER_TYPE_ERROR_MESSAGE),
  p: Yup.number().typeError(NUMBER_TYPE_ERROR_MESSAGE),
  img: Yup.number().typeError(NUMBER_TYPE_ERROR_MESSAGE),
  a: Yup.number().typeError(NUMBER_TYPE_ERROR_MESSAGE),
})

export const metricFields = [
  {
    type: 'text',
    name: 'content_length',
    label: 'Content Length',
    required: false,
    fieldProps: { placeholder: '1600' },
  },
  {
    type: 'text',
    name: 'hx',
    label: 'No. of Headings',
    required: false,
    fieldProps: { placeholder: '6' },
  },
  {
    type: 'text',
    name: 'p',
    label: 'No. of Paragraphs',
    required: false,
    fieldProps: { placeholder: '7' },
  },
  {
    type: 'text',
    name: 'img',
    label: 'No. of Images',
    required: false,
    fieldProps: { placeholder: '3' },
  },
  {
    type: 'text',
    name: 'a',
    label: 'No. of Links',
    required: false,
    fieldProps: { placeholder: '4' },
  },
]

export type MetricFormValues = {
  content_length: number
  hx: number
  p: number
  img: number
  a: number
}

export const initialKeywordValue = {
  min: '',
  max: '',
  keyword: '',
  heading_presence: 0,
}

export const keywordValidationSchema = Yup.object().shape({
  keyword: Yup.string().required('Please add valid Keyword'),
  heading_presence: Yup.boolean(),
  min: Yup.number()
    .typeError(NUMBER_TYPE_ERROR_MESSAGE)
    .min(0, 'Value should be positive number')
    .required('Please add valid value'),
  max: Yup.number()
    .typeError(NUMBER_TYPE_ERROR_MESSAGE)
    .min(Yup.ref('min'), 'Value must be greater than min value')
    .required('Please add valid value'),
})
